var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixpanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10167_18738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.06363 13.3749H13.0639C12.0648 12.75 11.6911 11.8742 11.1892 10.2504L9.68831 4.68785C9.00192 2.18826 8.43865 1 5.68809 1H-0.0589384V2.50072H0.755277C2.44039 2.50072 2.62992 3.12561 3.13179 5.00031L4.44316 9.87644C5.12954 12.253 6.18997 13.3749 9.06363 13.3749ZM18.314 13.3749H22.3142C25.1879 13.3749 26.1866 12.2482 26.878 9.87644L28.1894 5.00031C28.691 3.12561 28.9372 2.50072 30.5659 2.50072H31.3801V1H25.6945C22.8822 1 22.319 2.1267 21.694 4.68785L20.1934 10.2504C19.6915 11.9358 19.3128 12.75 18.314 13.3749ZM13.0639 18.625H18.314V13.3749H13.0639V18.625ZM-0.0589384 31H5.68809C8.43865 31 9.00192 29.8117 9.68831 27.3121L11.1892 21.7496C11.6911 20.1256 12.0648 19.25 13.0639 18.625H9.06363C6.18997 18.625 5.12482 19.7519 4.43843 22.1237L3.12707 26.9998C2.6252 28.8744 2.44039 29.4991 0.750559 29.4991H-0.0636566L-0.0589384 31ZM25.685 31H31.3707V29.4991H30.5565C28.9325 29.4991 28.6815 28.8744 28.18 26.9998L26.8686 22.1237C26.1819 19.7471 25.1832 18.625 22.3048 18.625H18.314C19.3128 19.25 19.6773 20.0642 20.1792 21.7496L21.6798 27.3121C22.3048 29.8732 22.8728 31 25.685 31Z",
    fill: "#7856FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10167_18738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixpanel);
export default __webpack_public_path__ + "static/media/MIXPANEL.7d5448008c9e54122557f18c4c27586c.svg";
export { ForwardRef as ReactComponent };